/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'navigation.global-shortcuts.all-sites': 'Alle websites',
  'navigation.global-shortcuts.apps.align': 'Juster',
  'navigation.global-shortcuts.apps.analytics': 'Analyser',
  'navigation.global-shortcuts.apps.assets': 'Aktiver',
  'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
  'navigation.global-shortcuts.apps.company-hub': 'Virksomhedshub',
  'navigation.global-shortcuts.apps.compass': 'Compass',
  'navigation.global-shortcuts.apps.confluence': 'Confluence',
  'navigation.global-shortcuts.apps.focus': 'Focus',
  'navigation.global-shortcuts.apps.goals': 'Mål',
  'navigation.global-shortcuts.apps.home': 'Startside',
  'navigation.global-shortcuts.apps.jira': 'Jira',
  'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
  'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
  'navigation.global-shortcuts.apps.loom': 'Loom',
  'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
  'navigation.global-shortcuts.apps.projects': 'Projekter',
  'navigation.global-shortcuts.apps.studio': 'Studio',
  'navigation.global-shortcuts.apps.talent': 'Talent',
  'navigation.global-shortcuts.apps.teams': 'Teams',
  'navigation.global-shortcuts.apps.trello': 'Trello',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Luk',
  'navigation.global-shortcuts.menu-expand-item.site-aria-label': '{name}-website',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(ikke tilgængelig i øjeblikket)',
  'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Ikon for åbning af eksternt link',
  'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(indlæser)',
  'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(indlæser)',
  'navigation.global-shortcuts.shortcut-action.open-menu-label': 'åbn menu',
  'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
  'navigation.global-shortcuts.sites': '{productName}-websites',
};
